import { FormikContextType } from "formik";


export const onBlur = (form: FormikContextType<unknown>, onBlur: Function) => (e: any) => { onBlur(e); form.setFieldValue(e.target.name, e.target.value) }
export const onKeyDown = (form: FormikContextType<unknown>) => (e: any) => {
    if (e.code === 'Enter') {
        const target = e.target as HTMLInputElement;
        form.setFieldValue(target.name, target.value)
    }
}